import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import { SuccessResponse } from '../types';

export class PositionService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async setPositionsDeviceConfiguration(positionIds: number[], configurationProfileId: number): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    const payload = {
      positionIds,
      configurationProfileId,
    };
    return this.api.put(`organisation/${organisation}/positions/setConfigurationProfile`, payload);
  }

  public async clearConfigurationProfile(payload: any): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.put(`organisation/${organisation}/positions/clearConfigurationProfile`, payload);
  }

  public async setPositionsNotes(positionIds: number[], notes: string = ''): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.put(`organisation/${organisation}/positions/setNotes`, {
      positionIds,
      notes,
    });
  }

  public async setPositionsDeviceConfigurationBulk( positionIds: number[], configurationProfileId: number ): Promise<{ job_id: string }> {
    const organisation = store.getters.activeOrganisation[0].id;
    const payload = {
      position_ids: positionIds, configuration_profile_id: configurationProfileId,
    };
    return this.api.post(`organisation/${organisation}/positions/setConfigurationProfile/bulk`, payload);
  }
}

export default new PositionService();
